import SvgIcon from '../../utils/Icon';
import { ReactComponent as PerfilUsuario } from '../../assets/icons/perfilUsuario.svg';
import { ReactComponent as Editar } from '../../assets/icons/editar.svg';
import { ReactComponent as Usuario } from "../../assets/icons/usuario.svg";
import { useState, useRef } from 'react';
import { useDataUser } from '../../context/dataUserContext';
import ImageCropper from '../ImageCropper/ImageCropper';

const UserProfile = ({ userImage, tipoPerfil, onEdit, onGuardar, onCancelar, inputs, textareas, afiliadoEstado, isAfiliadoPrestarServicio, mostrarActivarPrestacionServicios, onActivarPrestacionServicios, setShowCompleteProfile, onPhotoChange, onPhotoAcceptAndSave }) => {
    const { role } = useDataUser();
    const [isEdit, setIsEdit] = useState(false);
    const [showImageCropper, setShowImageCropper] = useState(false);
    const [imageToCrop, setImageToCrop] = useState(null);
    const fileInputRef = useRef(null);

    const onHandleClickEdit = () => {
        setIsEdit(!isEdit);
        onEdit();
    }
    const onHandleCancelar = () => {
        setIsEdit(false);
        onCancelar();
    }
    const onHandleGuardar = () => {
        setIsEdit(false);
        onGuardar();
    }

    const handleImageChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            setImageToCrop(file);
            setShowImageCropper(true);
            // Limpiar el input para que pueda seleccionar el mismo archivo de nuevo si cancela
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    };

    const handleCropComplete = (croppedFile) => {
        if (!croppedFile) return;
        // Aplicar la foto en el padre (vista previa / estado)
        if (onPhotoChange) {
            try {
                onPhotoChange(croppedFile);
            } catch (error) {
                console.error('Error al ejecutar onPhotoChange:', error);
            }
        }
        // Si el padre quiere guardar al instante al pulsar "Usar esta foto"
        if (typeof onPhotoAcceptAndSave === 'function') {
            try {
                onPhotoAcceptAndSave(croppedFile);
            } catch (error) {
                console.error('Error al ejecutar onPhotoAcceptAndSave:', error);
            }
        }
        setShowImageCropper(false);
        setImageToCrop(null);
    };

    const handleCropCancel = () => {
        setShowImageCropper(false);
        setImageToCrop(null);
    };

    return (
        <div className="">
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="bg-[#1f94c2ff] px-4 py-1.5 border-b border-[#205087ff]">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center">
                            <SvgIcon Icon={PerfilUsuario} className={"w-5 h-5 text-white mr-2 shrink-0"} /> 
                            <span className="text-white font-semibold text-sm">{tipoPerfil}</span>
                        </div>

                        <span className="flex items-center space-x-2">
                            {!isEdit ? (
                                <button
                                    type="button"
                                    className="flex items-center gap-1.5 px-2.5 py-1 rounded-full cursor-pointer transition-all duration-200 shrink-0 bg-white/20 hover:bg-white/30 text-white"
                                    onClick={onHandleClickEdit}
                                    title="Editar tu perfil"
                                >
                                    <SvgIcon Icon={Editar} className="w-5 h-5" />
                                    <span className="text-sm font-medium">Editar tu perfil</span>
                                </button>
                            ) : (
                                <>
                                    <span className="text-sm text-white/90 font-medium hidden sm:inline">Editando perfil</span>
                                    <div 
                                        className="p-1.5 rounded-full cursor-pointer transition-all duration-200 shrink-0 bg-white text-[#205087ff] shadow-md"
                                        title="Modo edición activo"
                                    >
                                        <SvgIcon Icon={Editar} className="w-5 h-5" />
                                    </div>
                                </>
                            )}
                            {isEdit && (
                                <>
                                    <button
                                        type="button"
                                        className="flex items-center gap-1.5 px-2.5 py-1 rounded-full cursor-pointer transition-all duration-200 shrink-0 bg-white/20 hover:bg-white/30 text-white"
                                        onClick={onHandleGuardar}
                                        title="Guardar cambios"
                                    >
                                        <span className="text-sm font-medium">Guardar</span>
                                    </button>
                                    <button
                                        type="button"
                                        className="flex items-center gap-1.5 px-2.5 py-1 rounded-full cursor-pointer transition-all duration-200 shrink-0 bg-white/20 hover:bg-white/30 text-white"
                                        onClick={onHandleCancelar}
                                        title="Cancelar edición"
                                    >
                                        <span className="text-sm font-medium">Cancelar</span>
                                    </button>
                                </>
                            )}
                        </span>
                    </div>
                </div>

                {/* INICIO FORMULARIO */}
                <div className="bg-white grid grid-cols-1 md:grid-cols-3 gap-4 p-4">
                {/* Foto del Perfil */}
                <div className="flex flex-col items-center md:col-span-1">
                    {/* Foto de perfil - Circular minimalista */}
                    <div className="relative mb-2">
                        {userImage ? (
                            <img
                                src={userImage}
                                alt="Foto de perfil"
                                className="w-32 h-32 rounded-full object-cover border-2 border-[#1f94c2ff]"
                                referrerPolicy="no-referrer"
                            />
                        ) : (
                            <div className="w-32 h-32 rounded-full border-2 border-[#1f94c2ff] bg-[#1f94c2ff] flex items-center justify-center">
                                <SvgIcon Icon={Usuario} className={"w-16 h-16 text-white"} />
                            </div>
                        )}
                        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-full opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                            onClick={() => fileInputRef.current?.click()}
                        >
                            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                        </div>
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            onChange={handleImageChange}
                            className="hidden"
                        />
                    </div>
                    <button
                        type="button"
                        onClick={() => fileInputRef.current?.click()}
                        className="text-sm text-[#1f94c2ff] hover:text-[#205087ff] font-medium mb-2"
                    >
                        Cambiar foto de perfil
                    </button>
                    {role === 'doctor' && (
                        <div className="w-full">
                            {((afiliadoEstado === 'no_aprobado' && !isAfiliadoPrestarServicio) || mostrarActivarPrestacionServicios) && (
                                <>
                                    <div className="bg-blue-50 border border-[#1f94c2ff] rounded-lg p-3 mb-2">
                                        <div className="text-center">
                                            <div className="w-10 h-10 mx-auto mb-2 bg-[#1f94c2ff] rounded-full flex items-center justify-center">
                                                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                                </svg>
                                            </div>
                                            <h3 className="text-base font-semibold text-[#1f94c2ff] mb-1">¿Deseas atender pacientes?</h3>
                                            <p className="text-sm text-gray-600 mb-2">
                                                {mostrarActivarPrestacionServicios
                                                    ? 'Completa el perfil clínico completo para habilitar citas y teleconsultas.'
                                                    : 'Completa tu perfil profesional para comenzar'}
                                            </p>
                                            <button 
                                                className="w-full py-2 px-4 bg-[#1f94c2ff] text-white font-medium rounded hover:bg-[#205087ff] transition-colors"
                                                onClick={mostrarActivarPrestacionServicios ? onActivarPrestacionServicios : setShowCompleteProfile}
                                            >
                                                {mostrarActivarPrestacionServicios
                                                    ? 'Activar prestación de servicios'
                                                    : 'Completar mi perfil profesional'}
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                    {/* Textareas */}
                    {(textareas ?? []).map((textarea, index) => (
                        <div className="w-full mt-2" key={index}>
                            <label className={`block font-medium mb-1 ml-1 text-sm ${isEdit && !textarea.readOnly ? 'text-[#1f94c2ff]' : 'text-[#70706eff]'}`}>
                                {textarea.label}:
                                {isEdit && !textarea.readOnly && (
                                    <span className="ml-2 text-xs text-[#1f94c2ff]">✏️ Editable</span>
                                )}
                            </label>
                            <textarea
                                value={textarea.value}
                                readOnly={textarea.readOnly}
                                onChange={textarea.onChange || null}
                                className={`w-full px-3 py-2 border rounded focus:outline-none resize-none transition-all duration-200 ${
                                    textarea.readOnly 
                                        ? 'bg-gray-50 border-gray-200' 
                                        : isEdit
                                            ? 'bg-blue-50 border-2 border-[#1f94c2ff] shadow-sm focus:shadow-md focus:ring-2 focus:ring-[#1f94c2ff]'
                                            : 'border-[#6e787aff] bg-white focus:border-[#1f94c2ff]'
                                }`}
                                rows="3"
                            />
                        </div>
                    ))}
                </div>

                {/* Campos del Formulario */}
                {/* Inputs */}
                <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {(inputs ?? []).map((input, index) => (
                        <div key={index}>
                            <label className={`block font-medium mb-1 ml-1 text-sm ${isEdit && !input.readOnly ? 'text-[#1f94c2ff]' : 'text-[#70706eff]'}`}>
                                {input.label}:
                                {isEdit && !input.readOnly && (
                                    <span className="ml-2 text-xs text-[#1f94c2ff]">✏️ Editable</span>
                                )}
                            </label>
                            {input.type === 'select' ? (
                                <select
                                    value={input.value}
                                    disabled={input.readOnly}
                                    onChange={input.onChange || null}
                                    className={`w-full px-3 py-2 border rounded focus:outline-none transition-all duration-200 ${
                                        input.readOnly 
                                            ? 'bg-gray-50 border-gray-200 cursor-not-allowed' 
                                            : isEdit
                                                ? 'bg-blue-50 border-2 border-[#1f94c2ff] shadow-sm focus:shadow-md focus:ring-2 focus:ring-[#1f94c2ff]'
                                                : 'border-[#6e787aff] bg-white focus:border-[#1f94c2ff]'
                                    }`}
                                >
                                    {(input.options ?? []).map((option, optIndex) => (
                                        <option key={optIndex} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            ) : (
                                <input
                                    type={input.type}
                                    value={input.value}
                                    readOnly={input.readOnly}
                                    onChange={input.onChange || null}
                                    className={`w-full px-3 py-2 border rounded focus:outline-none transition-all duration-200 ${
                                        input.readOnly 
                                            ? 'bg-gray-50 border-gray-200' 
                                            : isEdit
                                                ? 'bg-blue-50 border-2 border-[#1f94c2ff] shadow-sm focus:shadow-md focus:ring-2 focus:ring-[#1f94c2ff]'
                                                : 'border-[#6e787aff] bg-white focus:border-[#1f94c2ff]'
                                    }`}
                                />
                            )}
                        </div>
                    ))}
                </div>

                {role === 'doctor' && afiliadoEstado === 'en_revision' && isAfiliadoPrestarServicio && (
                    <div className="bg-yellow-50 border-l-4 border-yellow-400 rounded p-3 mb-3 col-span-full">
                        <div className="flex items-start">
                            <div className="flex-shrink-0">
                                <div className="w-6 h-6 bg-yellow-400 rounded-full flex items-center justify-center">
                                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                            </div>
                            <div className="ml-2 flex-1">
                                <h3 className="text-sm font-semibold text-yellow-800 mb-1">Revisión en Progreso</h3>
                                <p className="text-sm text-yellow-700">
                                    Tu perfil y documentos se encuentran en revisión, pronto recibirás una respuesta.
                                </p>
                            </div>
                        </div>
                    </div>
                )}
                {role === 'doctor' && afiliadoEstado === 'rechazado' &&  isAfiliadoPrestarServicio && (
                    <div className="bg-red-50 border-l-4 border-red-400 rounded p-3 mb-3 col-span-full">
                        <div className="flex items-start">
                            <div className="flex-shrink-0">
                                <div className="w-6 h-6 bg-red-400 rounded-full flex items-center justify-center">
                                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                    </svg>
                                </div>
                            </div>
                            <div className="ml-2 flex-1">
                                <h3 className="text-sm font-semibold text-red-800 mb-1">Documentos Rechazados</h3>
                                <p className="text-sm text-red-700">
                                    Tu perfil y documentos han sido rechazados. Puedes reemplazar los documentos en la sección <strong>Documentos almacenados</strong> más abajo y guardar los cambios.
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                </div>
            </div>
            {showImageCropper && imageToCrop && (
                <ImageCropper
                    imageFile={imageToCrop}
                    onCropComplete={handleCropComplete}
                    onCancel={handleCropCancel}
                />
            )}
        </div>
    )
}

export default UserProfile;